module.exports = __webpack_public_path__ + "img/character.2df013fb.png";